export { default } from './Ratings.component';
export * from './Ratings.component';
